import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import Services from './pages/Services'
import Quote from './pages/Quote'
import NotFound from './pages/NotFound'
import ServerError from './pages/ServerError'
import Footer from './Footer'

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  // Close mobile menu when clicking on a link
  const handleLinkClick = () => {
    setMobileMenuOpen(false)
  }

  return (
    <Router>
      <div className="app">
        <nav className="navigation bg-white shadow-lg sticky top-0 z-50 backdrop-blur-sm bg-white/95">
          <div className="container mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              {/* Logo */}
              <div className="flex items-center">
                <Link to="/" onClick={handleLinkClick} className="flex items-center transform hover:scale-105 transition-transform duration-300">
                  <img src="/prata_logo.svg" alt="Prata" className="h-12 w-auto mr-4" />
                  <div className="hidden lg:block">
                    <div className="text-sm font-semibold text-gray-700 leading-tight">
                      <span className="text-[#2F5496]">P</span>recisão <span className="text-[#2F5496]">R</span>acional <span className="text-[#2F5496]">A</span>plicada à
                    </div>
                    <div className="text-sm font-semibold text-gray-700 leading-tight">
                      <span className="text-[#2F5496]">T</span>ecnologia <span className="text-[#2F5496]">A</span>vançada
                    </div>
                  </div>
                </Link>
              </div>

              {/* Hamburger button - visible on mobile */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden flex flex-col justify-center items-center w-10 h-10 space-y-1.5 focus:outline-none"
                aria-label="Toggle menu"
              >
                <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
                <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
              </button>

              {/* Desktop menu - hidden on mobile */}
              <ul className="hidden md:flex space-x-8">
                <li>
                  <Link to="/" className="text-gray-700 hover:text-[#2F5496] font-medium transition-all duration-300 transform hover:scale-105 relative group">
                    Início
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#2F5496] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-700 hover:text-[#2F5496] font-medium transition-all duration-300 transform hover:scale-105 relative group">
                    Serviços
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#2F5496] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-700 hover:text-[#2F5496] font-medium transition-all duration-300 transform hover:scale-105 relative group">
                    Sobre
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#2F5496] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-700 hover:text-[#2F5496] font-medium transition-all duration-300 transform hover:scale-105 relative group">
                    Contato
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#2F5496] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </li>
                <li>
                  <Link to="/quote" className="bg-[#2F5496] text-white px-4 py-2 rounded-lg hover:bg-[#1e40af] transition-all duration-300 transform hover:scale-105 font-medium">
                    Orçamento
                  </Link>
                </li>
              </ul>
            </div>

            {/* Mobile menu - slides down from top */}
            <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${mobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
              <ul className="flex flex-col space-y-4 py-4 border-t border-gray-200">
                <li>
                  <Link to="/" onClick={handleLinkClick} className="block text-gray-700 hover:text-[#2F5496] font-medium transition-colors duration-300 py-2">
                    Início
                  </Link>
                </li>
                <li>
                  <Link to="/services" onClick={handleLinkClick} className="block text-gray-700 hover:text-[#2F5496] font-medium transition-colors duration-300 py-2">
                    Serviços
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={handleLinkClick} className="block text-gray-700 hover:text-[#2F5496] font-medium transition-colors duration-300 py-2">
                    Sobre
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={handleLinkClick} className="block text-gray-700 hover:text-[#2F5496] font-medium transition-colors duration-300 py-2">
                    Contato
                  </Link>
                </li>
                <li>
                  <Link to="/quote" onClick={handleLinkClick} className="block bg-[#2F5496] text-white px-4 py-3 rounded-lg hover:bg-[#1e40af] transition-all duration-300 font-medium text-center">
                    Orçamento
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/500" element={<ServerError />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
